import {checkAuthenticated} from '../../actions/AuthenticationActionCreators';

function requireRole(role) {
  async function requiresRole(nextState) {
    const context = nextState.routes[0].getContext();
    const RouteStore = context.getStore('RouteStore');
    const shouldCheck = RouteStore.getCurrentPath() !== nextState.location.pathname;
    const toReturn = {};

    if (shouldCheck) {
      console.info('Checking for role', role);
      await context.executeAction(checkAuthenticated, {routes: nextState.routes});

      const PortalUserStore = context.getStore('PortalUserStore');
      if (!PortalUserStore.userHasRole(role)) {
        console.info('User does not have the required role to access the given resource', {
          role,
          nextState
        });
        toReturn.redirect = {
          pathname: '/'
        };
      }
    }

    return toReturn;
  }

  return requiresRole;
}

export default requireRole;



// WEBPACK FOOTER //
// ./src/utils/route/requireRole.js